import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { SalesTab, WhatsAppTab, Stats, GuideSettings, PopupSettings } from "@/pages/admin/Sales";
import { PaymentRequests } from "@/pages/admin/PaymentRequests";
import { FreeFunnel } from "@/pages/admin/FreeFunnel";
import { ProductSettings } from "@/pages/admin/ProductSettings";
import { AbReport } from "@/pages/admin/AbReport";
import { LandingImages } from "@/pages/admin/LandingImages";

const SECTIONS = [["requests", "Payment Requests"], ["leads", "Leads"], ["abtest", "A/B Test"], ["images", "Landing images"], ["analytics", "Analytics"], ["pricing", "Pricing & Popup"], ["whatsapp", "WhatsApp Templates"]];

export default function SalesPage() {
  return (
    <div data-testid="sales-page">
      <PageHeader eyebrow="Super Admin" title="Sales" subtitle="Leads, guide pricing, landing popup and WhatsApp follow-up." />
      <Tabs defaultValue="requests">
        <TabsList className="bg-[#F5F0E6] rounded-xl flex-wrap h-auto">
          {SECTIONS.map(([k, l]) => <TabsTrigger key={k} value={k} className="rounded-lg" data-testid={`sales-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="requests" className="mt-5"><PaymentRequests /></TabsContent>
        <TabsContent value="leads" className="mt-5"><SalesTab /></TabsContent>
        <TabsContent value="abtest" className="mt-5"><AbReport /></TabsContent>
        <TabsContent value="images" className="mt-5"><LandingImages /></TabsContent>
        <TabsContent value="analytics" className="mt-5 space-y-5"><FreeFunnel /><Stats refresh={0} /></TabsContent>
        <TabsContent value="pricing" className="mt-5 space-y-5"><GuideSettings /><ProductSettings /><PopupSettings /></TabsContent>
        <TabsContent value="whatsapp" className="mt-5"><WhatsAppTab /></TabsContent>
      </Tabs>
    </div>
  );
}
